import {Vue, Component, Prop, PropSync, Provide, ProvideReactive, Watch} from 'vue-property-decorator';
import {CreditService} from "@/app/services/credit.service";
import {Inject} from "inversify-props";
import Helpers from "@/app/shared/common/helpers";

@Component<AirlineCreditOverlay>({
  components: ({})
})
export default class AirlineCreditOverlay extends Vue {
  @Inject() public creditService: CreditService;
  @Prop({default: true}) creditUsageEnabled: boolean;

  public readonly modalId = "ac-ui-overlay";
  public readonly modalTitle = "Rebooking Your Trip";
  public creditData: any = null;
  public selectedCredits: any[] = [];

  protected creditOptions: any[] = [];

  public showIncompleteSelectionWarning = false;
  public selectAll = false;

  @Watch("selectedCredits", {deep: true, immediate: true})
  onSelectedCreditsUpdated(newVal: any[], oldVal: any[]){
    if(newVal.length < this.paxesWithAirlineCredit.length){
      this.selectAll = false;
    }else if(newVal.length > 0 && newVal.length === this.paxesWithAirlineCredit.length){
      this.selectAll = true;
      this.showIncompleteSelectionWarning = false;
    }
  }

  public constructor() {
    super();
  }

  public mounted() {
    this.show();
    return true;
  }

  public created() {
    return true;
  }

  public destroyed() {
    return true;
  }

  public updated() {
    return true;
  }

  public get paxesWithAirlineCredit(){
    let pwc: any[] = [];
    if(this.creditData) {
      for (let paxId in this.creditData.credit_data.passengers_credit) {
        pwc.push(this.creditData.credit_data.passengers_credit[paxId]);
      }
    }
    return pwc;
  }

  /**
   * Returns the airline credit options for a single passenger
   * @param personId
   */
  public paxAirlineCreditOptions(personId: number){
    let options = [];
    let pwcExpanded = this.paxesWithAirlineCredit;
    for(let pwcItem of pwcExpanded){
      if(pwcItem.hasOwnProperty('person_id') && pwcItem.person_id == personId){
        options.push({
          item: pwcItem, name: pwcItem.person_name_full
        });
      }
    }
    return options;
  }

  /**
   * Returns the credit options for all paxes
   */
  public get allPaxAirlineCreditOptions(){
    if(this.creditOptions.length === 0){
      let options = [];
      let pwcExpanded = this.paxesWithAirlineCredit;
      const totalPaxCount = this.paxesWithAirlineCredit.length;
      for(let pwcItem of pwcExpanded){
        let optionLabel = pwcItem.airline_name;
        if(totalPaxCount > 1){
          optionLabel = pwcItem.person_name_full + " - " + pwcItem.airline_name;
        }
        options.push({
          item: JSON.parse(JSON.stringify(pwcItem)), name: optionLabel
        });
      }
      this.creditOptions = Array.from(options);
    }
    return this.creditOptions;
  }

  public get selectedAirlineCreditMini(){
    let formatted: any[] = [];
    for(let cItem of this.selectedCredits){
      formatted.push({
        person_id: cItem.person_id,
        airline_code: cItem.airline_credit_details.length > 0 ? cItem.airline_credit_details[0].carrier_airline_code : null
      });
    }
    return formatted;
  }

  public init(){
    this.creditData = this.$store.state.creditData;
  }

  public show(){
    this.init();
    this.$bvModal.show(this.modalId);
  }

  public hide(){
    this.$bvModal.hide(this.modalId);
  }

  public onSelectAllChanged(val: boolean){
    if(val){
      this.selectedCredits = [];
      const paxesWithCredit = this.paxesWithAirlineCredit;
      for(const p of paxesWithCredit){
        const options = this.paxAirlineCreditOptions(p.person_id);
        for (const option of options){
          this.selectedCredits.push(Object.freeze(option.item));
        }
      }
    } else {
      this.selectedCredits = [];
    }
  }

  public onContinueBtnClick(){
    if(this.paxesWithAirlineCredit.length > this.selectedCredits.length && !this.showIncompleteSelectionWarning){
      this.showIncompleteSelectionWarning = true;
      return false;
    }
    this.sendSelectionToIndie()
      .then((res) => {
        this.$store.dispatch("storeSelectedAirlineCreditOptions", this.selectedCredits);
        this.$emit(
            'airline-credit-selection-accepted',
            this.selectedCredits,
            this.creditData.credit_data.order_flights
        );
        this.$bvModal.hide(this.modalId);
      })
      .catch((err) => {
        Helpers.makeErrorToast(this, this.$bvToast, "Please try again");
    });

  }

  protected sendSelectionToIndie(){
    return this.creditService.storeSelectedAirlineCredit(this.selectedAirlineCreditMini, this.$store);
  }

}
